import { Container, Grid, GridItem } from '@chakra-ui/react';
import { Footer, HeroSection, TicketsBox, TicketsFilters } from 'components';
import { sampleHotels } from 'data';
import { Heading } from 'elements';
import { HERO_IMG_URL } from 'data';

const Tickets = () => {
  return (
    <>
      <Container maxW='container.xl'>
        <HeroSection filter={<TicketsFilters />} heading='One place, for everything' bgImage={HERO_IMG_URL.trip_packs} />
      </Container>
      <Container maxW='container.xl' padding='1.5rem 3rem'>
        <Heading />
      </Container>
      <Container maxW='container.xl'>
        <Grid templateColumns='repeat(auto-fit, minmax(300px, 1fr))' gap={5}>
          {sampleHotels.map((data) => (
            <GridItem rowSpan={1} colSpan={1} key={data.id}>
              <TicketsBox data={data} />
            </GridItem>
          ))}
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export { Tickets };
